import { DOCUMENTATION_TYPES, INSURANCE_CARD_SIDE } from '../index';

export const INSURANCES_CARD_KEYS_MAPPER = new Map([
  [INSURANCE_CARD_SIDE.FRONT, DOCUMENTATION_TYPES.CARD_1],
  [INSURANCE_CARD_SIDE.BACK, DOCUMENTATION_TYPES.CARD_2],
]);



// WEBPACK FOOTER //
// ./src/constants/insurance/insurance-card-keys-mapper.js